
enum AuthenticationResult {
    PENDING = "",
    SUCCESS = "success",
    INVALID_CREDENTIALS = "Invalid Username/Password Combination",
    TIMEOUT = "Validation Timed Out"
}

export {AuthenticationResult}